import { render } from "./product_in_main_w.vue?vue&type=template&id=9586f794&scoped=true"
import script from "./product_in_main_w.vue?vue&type=script&lang=js"
export * from "./product_in_main_w.vue?vue&type=script&lang=js"

import "./product_in_main_w.vue?vue&type=style&index=0&id=9586f794&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9586f794"]])

export default __exports__